import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { map, catchError } from 'rxjs/operators';
import {AccreditedModel} from '../../models/accredited.model';
import {ReceiptModel} from '../../models/receipt.model';

@Injectable()
export class AccreditedService {

  public URL_VERIFY = '[ACCREDITED]/auth/verify';
  public URL_LIST = '[ACCREDITED]/account/accreditedsallowreceipt';
  public URL_ADD = '[ACCREDITED]/accredited/receipt';
  public URL_LIST_RECEIPT = '[ACCREDITED]/accredited/receipts';
  public URL_LIST_RECEIPT_BY_ACCREDITED = '[ACCREDITED]/accredited/receipts/[accreditedID]';

  constructor(private http: Http) { }

  list(): Observable<AccreditedModel[]> {
    return this.http.get(this.URL_LIST)
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error getting accrediteds list'))
      );
  }

  listReceipts(accreditedId: any): Observable<ReceiptModel[]> {
    let url = this.URL_LIST_RECEIPT;
    if (accreditedId) {
      url = this.URL_LIST_RECEIPT_BY_ACCREDITED.replace('[accreditedID]', accreditedId);
    }
    return this.http.get(url)
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error getting receipts list'))
      );
  }

  verify(): Observable<any> {
    return this.http.get(this.URL_VERIFY)
      .pipe(
        map((res: Response) => {
          return res.text();
        }),
        catchError(() => of('Error, could not verify if you are logged'))
      );
  }

  addReceipt(receiptObj: any): Observable<any> {
    const encodString = btoa(receiptObj.operator.substr(0, 2) + ':' + receiptObj.operator.substr(2, 4));
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('EmployeeAuthorization', `Basic ${encodString}`);
    return this.http.post(this.URL_ADD, receiptObj, options)
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Erro on insert new receipt'))
      );
  }
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/accredited/accredited.service.ts